export const NotificationRouteList = [
  {
    title: 'System User Approval',
    url: '/task/user-approval',
  },
  {
    title: 'System User',
    url: '/settings/organization-settings/users',
  },
  {
    title: 'Dashboard',
    url: '/overview',
  },
  {
    title: 'Plan Approval',
    url: '/settings/organization-settings/task/plan-approval',
  },
  {
    title: 'Performance Rule Approver',
    url: '/settings/organization-settings/task/performance-rule-approval',
  },
  {
    title: 'Plan',
    url: '/settings/organization-settings/plan-management',
  },
  {
    title: 'Performance Rule',
    url: '/settings/organization-settings/performance-rule',
  },
  {
    title: 'Participant Approval',
    url: '/settings/organization-settings/task/participants-approval',
  },
  {
    title: 'Participant',
    url: '/participants',
  },
  {
    title: 'RSU Approval',
    url: '/settings/organization-settings/task/rsu-awards-approval',
  },
  {
    title: 'PSU Approval',
    url: '/settings/organization-settings/task/psu-awards-approval',
  },
  {
    title: 'RSU',
    url: '/awards/rsu-awards',
  },
  {
    title: 'PSU',
    url: '/awards/psu-awards',
  },
  {
    title: 'Option Approval',
    url: '/settings/organization-settings/task/option-awards-approval',
  },
  {
    title: 'Option',
    url: '/awards/option-awards',
  },
  {
    title: 'Pre-Clearance Request',
    url: '/settings/organization-settings/task/pre-clearance-requests',
  },
  {
    title: 'Tax Approval',
    url: '/settings/organization-settings/task/tax-setup-approval',
  },
];
